import React, { Component } from 'react';

class Neutral extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let color = this.props.color && this.props.color!==''?this.props.color:"#1E4691";
        return(
            <React.Fragment>
                <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.04892 19.2266H18.497" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path className='hovered' d="M8.73015 13.0941C9.73369 13.0941 10.5472 11.9755 10.5472 10.5956C10.5472 9.21577 9.73369 8.09717 8.73015 8.09717C7.72661 8.09717 6.91309 9.21577 6.91309 10.5956C6.91309 11.9755 7.72661 13.0941 8.73015 13.0941Z" fill="white" stroke="white"/>
                    <path className='hovered' d="M18.2698 13.0941C19.2733 13.0941 20.0868 11.9755 20.0868 10.5956C20.0868 9.21577 19.2733 8.09717 18.2698 8.09717C17.2662 8.09717 16.4527 9.21577 16.4527 10.5956C16.4527 11.9755 17.2662 13.0941 18.2698 13.0941Z" fill="white" stroke="white"/>
                    <path fill="none" d="M13.5 26.2678C20.3993 26.2678 25.9923 20.6748 25.9923 13.7755C25.9923 6.8762 20.3993 1.2832 13.5 1.2832C6.60072 1.2832 1.00772 6.8762 1.00772 13.7755C1.00772 20.6748 6.60072 26.2678 13.5 26.2678Z" stroke="white" strokeWidth="2"/>
                </svg>
                {this.props.text && this.props.text==='true'?(
                    <span>Neutral</span>
                ):(null)}
            </React.Fragment>
        )
    }
}
Neutral.propTypes = {
    color: React.propTypes.node,
    text: React.propTypes.node,
}
export default Neutral;